<!-- Styled in src/_chat-menu.scss: the menu renders in the CDK overlay, out of reach of component styles. -->
<mat-menu [xPosition]="xPosition" class="chat-conv-menu">
  <div class="chat-menu" *ngIf="conversation as c" [style.--chat-menu-accent]="accent">
    <button mat-menu-item *ngIf="actions.fileOf(c) as ref" (click)="actions.openFile(ref)"><mat-icon>visibility</mat-icon><span>Open patient file</span></button>
    <button mat-menu-item (click)="actions.info(c)"><mat-icon>info</mat-icon><span>Details</span></button>
    <ng-container *ngIf="c.access === 'participant'">
      <button mat-menu-item (click)="actions.pin(c, !c.pinnedAt)"><mat-icon>push_pin</mat-icon><span>{{ c.pinnedAt ? 'Unpin' : 'Pin to top' }}</span></button>
      <mat-divider></mat-divider>
      <div class="chat-menu-label">Notify me about</div>
      <button mat-menu-item [class.selected]="(c.notifyLevel || 'all') === 'all'" (click)="actions.setNotify(c, 'all')">
        <mat-icon>{{ (c.notifyLevel || 'all') === 'all' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon><span>Every message</span>
      </button>
      <button mat-menu-item [class.selected]="c.notifyLevel === 'mentions'" (click)="actions.setNotify(c, 'mentions')">
        <mat-icon>{{ c.notifyLevel === 'mentions' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon><span>Only when I'm mentioned</span>
      </button>
      <button mat-menu-item [class.selected]="c.notifyLevel === 'none'" (click)="actions.setNotify(c, 'none')">
        <mat-icon>{{ c.notifyLevel === 'none' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon><span>Nothing</span>
      </button>
      <mat-divider></mat-divider>
      <div class="chat-menu-label">Mute</div>
      <button mat-menu-item class="selected" *ngIf="actions.muted(c)" (click)="actions.mute(c, null)"><mat-icon>notifications_active</mat-icon><span>Unmute</span></button>
      <ng-container *ngIf="!actions.muted(c)">
        <button mat-menu-item (click)="actions.mute(c, 8)"><mat-icon>schedule</mat-icon><span>For 8 hours</span></button>
        <button mat-menu-item (click)="actions.mute(c, 24 * 7)"><mat-icon>date_range</mat-icon><span>For a week</span></button>
        <button mat-menu-item (click)="actions.mute(c, 'always')"><mat-icon>notifications_off</mat-icon><span>Until I unmute</span></button>
      </ng-container>
    </ng-container>
  </div>
</mat-menu>
